export default {
  path: 'settings/products/:id',
  name: 'TemporaryRegulationsProductDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ProductDetails.vue')
}
